import React from 'react';
import {ErrorBoundary} from '@sentry/react';
import {__} from 'js/tool/page/current';
import Alert from 'react-bootstrap/Alert';

interface IProps {
	children: React.ReactNode;
}

function ErrorBoundaryComp({children}: IProps) {
	return (
		<ErrorBoundary
			fallback={
				<Alert
					variant="info"
					className="error-alert"
				>
					<i className="fas fa-exclamation-triangle"/>
					{__('An error has occoured, we are already working on it!')}
				</Alert>
			}
		>
			{children}
		</ErrorBoundary>
	);
}

export default ErrorBoundaryComp;
